<h2 mat-dialog-title>Manage Delivery</h2>

<mat-dialog-content class="dialog-content">
  <p><strong>Tracking ID:</strong> {{ data.activity.trackingId }}</p>
  <p><strong>Sender:</strong> {{ data.activity.customerName }}</p>
  <p><strong>Receiver:</strong> {{ data.activity.receiverName }}</p>
  <p><strong>Current Status:</strong> {{ data.activity.status }}</p>
  <p><strong>Assigned Rider:</strong> {{ data.activity.assignedRider || 'Unassigned' }}</p>

  <form [formGroup]="form">
    <mat-form-field appearance="fill" class="full-width" *ngIf="canAssign()">
      <mat-label>Assign Rider</mat-label>

      <mat-select formControlName="riderId">
        <mat-option *ngIf="isLoadingRiders" disabled>Loading riders...</mat-option>
        <mat-option *ngFor="let r of riders" [value]="r.id">
          {{ r.fullName || r.name || r.email }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="info-chip" *ngIf="!canAssign()">
      Rider assignment is restricted for your account.
    </div>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Update Status</mat-label>
      <mat-select formControlName="status">
        <mat-option *ngFor="let s of statuses" [value]="s">{{ s }}</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
